import React, { useContext } from 'react';
import styles from './MyWidgetHeader.module.scss';
import { SFButton } from 'sfui';
import { MediaContext, SubscriptionContext } from 'ui-smartforce-settings';

export interface MyWidgetHeaderProps {
  className?: string;
  workspaceName?: string;
  disabled: boolean;
  onAddWidgets: () => void;
}

export const MyWidgetHeader = ({
  className = '',
  workspaceName,
  disabled,
  onAddWidgets
}: MyWidgetHeaderProps): React.ReactElement<MyWidgetHeaderProps> => {
  const { subscriptionsSummary } = useContext(SubscriptionContext);
  const { isPhone } = useContext(MediaContext);

  return (
    <div className={`${styles.myWidgetHeader} ${className}`}>
      <h2>
        {subscriptionsSummary.appPlan.nexus ? workspaceName : 'My Widgets'}
      </h2>

      <SFButton
        variant="contained"
        sfColor="blue"
        size={isPhone ? 'large' : 'medium'}
        fullWidth={isPhone}
        onClick={onAddWidgets}
        disabled={disabled}
      >
        Manage Widgets
      </SFButton>
    </div>
  );
};
